import type { ReactNode } from "react";
import { SectionCard } from "@/components/SectionCard";
import { cn } from "@/lib/utils";

// #design-pass W5: Key-Value-Zeile + "Eigenschaften"-Sidebar-Panel.
// KvRow war lokal in Agents/Detail — jetzt geteilt (DRY) über alle Detailseiten.
export function KvRow({ label, value, last }: { label: ReactNode; value: ReactNode; last?: boolean }) {
  return (
    <div className={cn("flex flex-col gap-1 py-[11px]", !last && "border-b border-border")}>
      <span className="text-[11.5px] font-semibold text-text3">{label}</span>
      <span className="text-[13.5px] text-text">{value}</span>
    </div>
  );
}

// rows: [Label, Wert]-Paare. Rendert die Sidebar-Card "Eigenschaften".
export function PropGrid({
  rows,
  title = "Eigenschaften",
}: {
  rows: Array<[ReactNode, ReactNode]>;
  title?: string;
}) {
  return (
    <SectionCard title={title}>
      <div className="-my-[11px]">
        {rows.map(([label, value], i) => (
          <KvRow key={i} label={label} value={value} last={i === rows.length - 1} />
        ))}
      </div>
    </SectionCard>
  );
}
